import React, { useState, useEffect, useContext, useCallback } from "react";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Upload, Modal, Button, notification } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { MaxiColors } from "../../../../theme";
import * as markersIcon from "../../../../assets/markersIcon";
import {
  clearRepairDetail,
  setRepairDetail,
  updateLayerDetail,
} from "../../../../actions/boldgroup/repairPointAction";
import { authUserContext } from "../../../../contexts/authContext";
import { numericInput } from "../../../../utils/utils";
const { confirm } = Modal;

const initDetail = { files: [] };

const RepairCoreDetail = ({ layerDetail, onClose, onEdit }) => {
  const { repairDetail, marker } = useSelector((state) => ({
    repairDetail: state.repairPoint?.repairDetail,
    marker: state.repairPoint?.repairDetail.markers.find((f) => f.active) || {
      latitude: 0,
      longitude: 0,
    },
  }));
  const dispatch = useDispatch();
  const [detail, setDetail] = useState(initDetail);
  const [isEdit, setIsEdit] = useState(false);
  const authUserValue = useContext(authUserContext);

  const handleUpdateLayerDetail = useCallback(
    async (request) => {
      try {
        await dispatch(updateLayerDetail(request));
      } catch (err) {
        throw err;
      }
    },
    [dispatch]
  );

  const handleConfirmUpdateLayerDetail = (request) => {
    confirm({
      title: "Do you Want to update item ?",
      icon: <ExclamationCircleOutlined />,
      content: `ต้องการแก้ไขรายการ`,
      onOk() {
        return handleUpdateLayerDetail(request)
          .then(() => {
            notification.success({
              message: "Success",
              description: "แก้ไขรายการสำเร็จ",
            });
            setDetail({});
            setIsEdit(false);
            dispatch(clearRepairDetail());
            onClose();
          })
          .catch((error) => {
            notification.error({
              message: "เกิดข้อผิดพลาด",
              description: error.message,
            });
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleChangeFile = ({ fileList }) => {
    setDetail({ ...detail, files: fileList });
  };

  useEffect(() => {
    const mapFiles = layerDetail.files.map((m) => ({
      ...m,
      uid: m.fileID,
      name: m.fileName,
      status: "done",
      url: m.fileURL,
    }));
    setDetail({ ...layerDetail, files: mapFiles });
    return () => {
      setDetail({});
      setDetail({});
      setIsEdit(false);
      dispatch(clearRepairDetail());
    };
  }, [dispatch, layerDetail]);

  return (
    <>
      <div className="draggable-repair-head">
        <div style={{ display: "flex", flex: 1 }}>
          ข้อมูล Core {detail.stationCode === 1 && "ต้นทาง"}
          {detail.stationCode === 2 && "ปลายทาง"}
        </div>
        <div style={{ display: "flex" }}>
          <CloseOutlined
            onClick={onClose}
            style={{ color: MaxiColors.DANGER }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <label className="mb-0">Latitude</label>
            {isEdit ? (
              <>
                <input
                  className="form-control form-control-sm"
                  value={marker.latitude || ""}
                  disabled
                />
                <span style={{ color: MaxiColors.DANGER, fontSize: 12 }}>
                  * กดที่แผนที่เพื่อระบุ
                </span>
              </>
            ) : (
              <input
                className="form-control form-control-sm"
                value={detail.latitude || ""}
                disabled
              />
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label className="mb-0">Longitude</label>
            {isEdit ? (
              <>
                <input
                  className="form-control form-control-sm"
                  value={marker.longitude || ""}
                  disabled
                />
                <span style={{ color: MaxiColors.DANGER, fontSize: 12 }}>
                  * กดที่แผนที่เพื่อระบุ
                </span>
              </>
            ) : (
              <input
                className="form-control form-control-sm"
                value={detail.longitude || ""}
                disabled
              />
            )}
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">Site/Node/Cust</label>
            <input
              className="form-control form-control-sm"
              value={detail.siteName || ""}
              disabled={!isEdit}
              onChange={(event) => {
                const { value } = event.target;
                setDetail({ ...detail, siteName: value });
              }}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">
              ระยะทางจาก Site - จุดที่มีปัญหา(เมตร)
            </label>
            <input
              className="form-control form-control-sm"
              value={detail.distanceRepairPoint || ""}
              disabled={!isEdit}
              onChange={(event) => {
                const { value } = event.target;
                setDetail({
                  ...detail,
                  distanceRepairPoint: numericInput(value),
                });
              }}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">หมายเหตุ</label>
            <textarea
              className="form-control form-control-sm"
              value={detail.remark || ""}
              disabled={!isEdit}
              onChange={(event) => {
                const { value } = event.target;
                setDetail({ ...detail, remark: value });
              }}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">ตำแหน่ง Core เดิม</label>
            <input
              className="form-control form-control-sm"
              value={detail.beforeCore || ""}
              disabled={!isEdit}
              onChange={(event) => {
                const { value } = event.target;
                setDetail({ ...detail, beforeCore: numericInput(value) });
              }}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">ตำแหน่ง Core ใหม่</label>
            <input
              className="form-control form-control-sm"
              value={detail.afterCore || ""}
              disabled={!isEdit}
              onChange={(event) => {
                const { value } = event.target;
                setDetail({ ...detail, afterCore: numericInput(value) });
              }}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="mb-0">รูปถ่าย</label>
            <Upload
              action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              listType="picture-card"
              fileList={detail.files}
              onChange={handleChangeFile}
              className="images-repair-point"
            >
              {/* {fileList.length >= 8 ? null : uploadButton} */}
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            </Upload>
          </div>
        </div>
      </div>
      <div className="row justify-content-center mt-2">
        {isEdit ? (
          <div className="col-12">
            <div className="row">
              <div className="col">
                <Button
                  style={{
                    backgroundColor: MaxiColors.BORDER,
                    width: "100%",
                  }}
                  onClick={() => {
                    setIsEdit(false);
                    onEdit(false);
                    dispatch(clearRepairDetail());
                  }}
                >
                  <span
                    className="default-thai-font"
                    style={{ color: MaxiColors.PRIMARY }}
                  >
                    CANCEL
                  </span>
                </Button>
              </div>
              <div className="col">
                <Button
                  style={{
                    backgroundColor: MaxiColors.ACCENT,
                    width: "100%",
                  }}
                  onClick={() => {
                    handleConfirmUpdateLayerDetail({
                      ...detail,
                      latitude: marker.latitude,
                      longitude: marker.longitude,
                      userName: authUserValue.username,
                    });
                  }}
                >
                  <span
                    className="default-thai-font"
                    style={{ color: MaxiColors.PRIMARY }}
                  >
                    SAVE
                  </span>
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-12">
            <Button
              style={{
                backgroundColor: MaxiColors.PRIMARY,
                width: "100%",
              }}
              onClick={() => {
                setIsEdit(true);
                onEdit(true);
                dispatch(
                  setRepairDetail({
                    ...repairDetail,
                    markers: [
                      {
                        active: true,
                        latitude: detail.latitude,
                        longitude: detail.longitude,
                        icon: markersIcon.customerNormal,
                      },
                    ],
                  })
                );
              }}
            >
              <span
                className="default-thai-font"
                style={{ color: MaxiColors.WHITE }}
              >
                EDIT  
              </span>
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default RepairCoreDetail;
